import { render, staticRenderFns } from "./SpeakingRoleplay.vue?vue&type=template&id=02330e16&scoped=true&"
import script from "./SpeakingRoleplay.vue?vue&type=script&lang=js&"
export * from "./SpeakingRoleplay.vue?vue&type=script&lang=js&"
import style0 from "./SpeakingRoleplay.vue?vue&type=style&index=0&id=02330e16&lang=scss&scoped=true&"
import style1 from "./SpeakingRoleplay.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02330e16",
  null
  
)

export default component.exports